<template>
  <a class="star-query-icon flex no-underline" @click.prevent="handleClick" href="#">
    <SolidStarIcon v-if="starred" class="star-query-icon__icon mr-4" />
    <LightStarIcon v-else class="star-query-icon__icon pointer mr-4" />
    <span class="font-small">Save query</span>
  </a>
</template>

<script>
import axios from "axios";
import log from "modules/log";
import { notify } from "modules/notify";
import SolidStarIcon from "@images/font_awesome/star-solid.svg";
import LightStarIcon from "@images/font_awesome/star-light.svg";

export default {
  name: "StarQueryIcon",
  components: {
    LightStarIcon,
    SolidStarIcon
  },
  data() {
    return {
      query: "",
      starred: false
    }
  },
  props: {
    queryBody: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick() {
      if(this.starred) {
        return;
      }

      let formData = new FormData();

      formData.append("body", this.query);

      axios.post("/api/queries/star.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
        }
      }).then(response => {
        this.starred = true;
      }).catch((error) => {
        log(error);

        notify({
          message: "Oops, something went wrong. Please, try again or ping support@sqlhabit.com",
          type: "error"
        });
      }).finally(() => {

      });
    }
  },
  mounted() {
    this.query = this.queryBody;
  }
}
</script>

<style lang="scss">
.star-query-icon {
  &__icon {
    width: 14px;
  }
}
</style>
